export default class FAQArticle {
    public question : string = '';
    public answer : string = '';

    constructor(init?: Partial<FAQArticle>){
        Object.assign(this, init);
    }
}